
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 5.4c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l8.1 8.1c-3.7 2.4-6.9 5.8-9 9.6l-.3.5.3.5c4.2 7.8 13.2 13.6 20.7 13.6 3.1 0 6.5-1 9.7-2.8l8.4 8.4c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L6.5 5.4zM20.3 22l7.6 7.5c-.9.6-1.9.9-3 .9-3 0-5.5-2.4-5.5-5.5 0-1 .3-2 .9-2.9zm4.6 15.1c-6.8 0-14.7-5.2-18.7-12.1 2-3.5 5-6.5 8.4-8.7l4.3 4.3c-.9 1.3-1.5 2.8-1.5 4.4 0 4.1 3.3 7.5 7.5 7.5 1.6 0 3.2-.5 4.4-1.5l3.8 3.8c-2.7 1.4-5.5 2.3-8.2 2.3zM45.6 24.5c-4.3-7.7-13.2-13.6-20.7-13.6-2.8 0-5.7.8-8.6 2.2l1.5 1.5c2.4-1 4.8-1.6 7.1-1.6 6.7 0 14.6 5.2 18.7 12.1-1.8 3.1-4.4 5.8-7.3 7.9l1.4 1.4c3.2-2.3 6-5.4 7.9-8.9l.1-.2v-.5l-.1-.3z"}}),_c('path',{attrs:{"d":"M31.6 28.3c.5-1 .8-2.1.8-3.3 0-4.1-3.3-7.5-7.5-7.5-1.2 0-2.3.3-3.3.8l1.5 1.5c.6-.2 1.1-.3 1.7-.3 3 0 5.5 2.4 5.5 5.5 0 .6-.1 1.2-.3 1.7l1.6 1.6z"}})])
          )
        }
      }
    